"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = autoFontPlugin;

var _fontfaceobserver = require("fontfaceobserver");

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * This module generated customers first name and lastname in handwritten font,
                                                                                                                                                                                                     * so that it looks almost like a real signature, and simplifies the signing up
                                                                                                                                                                                                     * process for customer. It also able of regenerating font on purpose
                                                                                                                                                                                                     */

/**
 * Init function for specific signature-pad element.
 * 
 * @param {DOM element} wrapper           The `.js-autofont-wrapper` DOM element 
 *                                        which contains canvas and div with 
 *                                        buttons
 * 
 * @param {string}     text               The text that should be rendered in
 *                                        canvas
 *
 * @param {function}   useButtonCallback  Function which will be executed when
 *                                        the `Use` button is clicked. 
 *                                        Callback recieves a data string which
 *                                        consist of font info, and looks like
 *                                        '69px rollerscript-smooth'
 */
function autoFontPlugin(wrapper, text) {
  var useButtonCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};


  var fonts = ["bouffant", "viktorie", "rollerscript-smooth", "ff-market-web", "austin-pen"];

  // pick a random element in the array
  var randomPicker = function randomPicker(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  };

  // picking up random font from fonts array and setting default fontSize
  var randomFont = randomPicker(fonts),
      fontSize = void 0,
      result = void 0;

  // check if the adobe fonts css is already appended in document.head 
  var checkCss = function checkCss() {
    var links = document.head.querySelectorAll('link');

    var cssIsFetched = [].concat(_toConsumableArray(links)).some(function (node) {
      return node.href === 'https://use.typekit.net/xet8civ.css';
    });

    if (!cssIsFetched) {
      var link = document.createElement('link');
      link.setAttribute('href', 'https://use.typekit.net/xet8civ.css');
      link.setAttribute('rel', 'stylesheet');
      document.head.appendChild(link);
    }
  };

  var changeFont = function changeFont(text, randomFont) {

    var autofont = wrapper.querySelector('.js-autofont');

    checkCss();

    //clear existing div
    autofont.innerHTML = '';

    var currentFont = new _fontfaceobserver2.default("" + randomFont);

    // doing manipulations with autofont rendering
    currentFont.load().then(function () {

      var textSpan = document.createElement('span');
      textSpan.innerHTML = text;
      autofont.appendChild(textSpan);
      fontSize = 90;

      do {
        fontSize--;
        textSpan.style = "font-family : " + randomFont + "; font-size : " + fontSize + "px";
      } while (textSpan.offsetWidth > wrapper.offsetWidth - 40 || textSpan.offsetHeight > wrapper.offsetHeight - 40);
      result = fontSize + "px " + randomFont;
    }).catch(function (e) {
      console.error(randomFont + "  failed to load.", e);
    });
  };

  var randomize = function randomize() {

    var compareFonts = function compareFonts(oldFont) {
      var newRandomFont = randomPicker(fonts);

      if (oldFont !== newRandomFont) {
        randomFont = newRandomFont;
        return changeFont(text, newRandomFont);
      } else {
        compareFonts(newRandomFont);
      }
    };
    compareFonts(randomFont);
  };

  if (wrapper !== null) {

    window.addEventListener('resize', function () {
      changeFont(text, randomFont);
    });

    changeFont(text, randomFont);
    var callback = function callback(e) {
      return useButtonCallback(e, result);
    };
    wrapper.querySelector('.js-autofont-randomize').addEventListener('click', randomize);
    wrapper.querySelector('.js-autofont-confirm').addEventListener('click', callback);
  }
}